import authHelper from 'src/api/auth/helper';

function Ctrl($scope, $rootScope, $state, currentUser, affiliate, keychain) {
  if (!affiliate) {
    $state.go('login');

    return;
  } else if (!affiliate.enabled) {
    $state.go('inactive');

    return;
  }

  $rootScope.currentUser = currentUser;
  $rootScope.affiliate = affiliate;

  if ($state.current.name === 'app') {
    $state.go('app.sales');
  }

  authHelper.setAuthToken(keychain.getConsumerAuthToken());
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  'currentUser',
  'affiliate',
  'jsSdk.keychain'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/app/appCtrl.js